import helpers from "../config";
import swal from "sweetalert";

export const PROFILE_DATA_LOADING = "PROFILE_DATA_LOADING";
export const SHOW_PROFILE_DATA = "SHOW_PROFILE_DATA";
export const PROFILE_LOAD_FAIL = "PROFILE_LOAD_FAIL";

export const RESUME_DATA_LOADING = "RESUME_DATA_LOADING";
export const SHOW_RESUME_DATA = "SHOW_RESUME_DATA";
export const RESUME_LOAD_FAIL = "RESUME_LOAD_FAIL";

export const DELETERESUME_DATA_LOADING = "DELETERESUME_DATA_LOADING";
export const SHOW_DELETERESUME_DATA = "SHOW_DELETERESUME_DATA";
export const DELETERESUME_LOAD_FAIL = "DELETERESUME_LOAD_FAIL";

export const DELETEVIDEO_DATA_LOADING = "DELETEVIDEO_DATA_LOADING";
export const SHOW_DELETEVIDEO_DATA = "SHOW_DELETEVIDEO_DATA";
export const DELETEVIDEO_LOAD_FAIL = "DELETEVIDEO_LOAD_FAIL";

export const LOADING_UPDATED_DATA = "LOADING_UPDATED_DATA";
export const DATA_UPDATED = "DATA_UPDATED";
export const DATA_UPDATED_FAIL = "DATA_UPDATED_FAIL";

export const PRESIGNED_URL_LOADING = "PRESIGNED_URL_LOADING";
export const PRESIGNED_URL_SUCCESS = "PRESIGNED_URL_SUCCESS";
export const PRESIGNED_URL_FAIL = "PRESIGNED_URL_FAIL";

// Helper function to fetch a single presigned URL
const fetchPresignedUrlInternal = async (s3Key, serverUrl) => {
  if (!s3Key) return null;
  // Assuming your API is at /api/jobseeker/presigned-url relative to serverUrl
  const response = await fetch(`${serverUrl}/admin/getPresignedUrl?key=${s3Key}`);
  if (!response.ok) {
    const errorBody = await response.text();
    throw new Error(`Failed to fetch presigned URL for ${s3Key}: ${response.status} ${errorBody}`);
  }
  const data = await response.json();
  return data.url;
};

export const getJobseekerProfile = (jobseekerId) => {
  return (dispatch) => {
    dispatch({ type: PROFILE_DATA_LOADING })
    helpers.getServerUrl().then(config => { // Renamed 'url' to 'config' to avoid shadowing
      var serverBaseUrl = config.serverUrl; // Use a distinct variable name
      // var fileUrl = config.imageUrl; // This might be used for other images

      fetch(serverBaseUrl + "/admin/getJsDetailById", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          jobseekerId: jobseekerId,
          loginFrom: "Web"
        })
      })
        .then(response => response.json())
        .then(responseData => {
          dispatch({
            type: SHOW_PROFILE_DATA,
            payload: responseData
          })
          // After successfully fetching profile data, fetch presigned URLs if paths exist
          if (
            responseData.videoResume ||
            responseData.resumeVideoThumb ||
            responseData.resumePdfThumb
          ) {
            dispatch(
              getPresignedUrls({
                videoKey: responseData.videoResume,
                videoThumbKey: responseData.resumeVideoThumb,
                resumePdfThumbKey: responseData.resumePdfThumb
              })
            );
          }

        })
        .catch(err => {
          dispatch({
            type: PROFILE_LOAD_FAIL,
            payload: err
          })
        })
    })
  }
}

export const getPresignedUrls = ({
  videoKey,
  videoThumbKey,
  resumePdfThumbKey
}) => {
  return async (dispatch) => {
    dispatch({ type: PRESIGNED_URL_LOADING });

    try {
      const config = await helpers.getServerUrl();
      const serverBaseUrl = config.serverUrl;

      const presignedMap = {};

      const resolveIfExists = async (key, targetField) => {
        if (!key) return;
        presignedMap[targetField] = await fetchPresignedUrlInternal(
          key,
          serverBaseUrl
        );
      };

      await Promise.all([
        resolveIfExists(videoKey, "videoResume"),
        resolveIfExists(videoThumbKey, "resumeVideoThumb"),
        resolveIfExists(resumePdfThumbKey, "resumePdfThumb")
      ]);

      console.log(
        "[ACTION] PRESIGNED_URL_SUCCESS payload:",
        presignedMap
      );

      dispatch({
        type: PRESIGNED_URL_SUCCESS,
        payload: presignedMap
      });

    } catch (err) {
      console.error("[ACTION] Presigned URL error:", err);
      dispatch({
        type: PRESIGNED_URL_FAIL,
        payload: err.message || err
      });
    }
  };
};

export const getResume = (jobseekerId) => {
  return (dispatch) => {
    dispatch({ type: RESUME_DATA_LOADING })
    helpers.getServerUrl().then(url => {
      var fileUrl = url.imageUrl
      fetch(fileUrl + "jobseeker/defaultResume", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          jobseekerId: jobseekerId
        })
      })
        .then(response => response.json())
        .then(response => {
          dispatch({
            type: SHOW_RESUME_DATA,
            payload: response
          })
          if (response.success) {
            return dispatch(getJobseekerProfile(jobseekerId));
          }
        })
        .catch(err => {
          dispatch({
            type: RESUME_LOAD_FAIL,
            payload: err
          })
        })
    })
  }
}

export const deleteResume = (jobseekerId) => {
  return (dispatch) => {
    dispatch({ type: DELETERESUME_DATA_LOADING })
    helpers.getServerUrl().then(url => {
      console.log('Got into getServerUrl===========', url)

      const fileUrl = url.imageUrl;
      console.log(fileUrl, 'will be deleting after this===========', jobseekerId)
      fetch(fileUrl + "jobseeker/deleteResume", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          jobseekerId: jobseekerId
        })
      })
        .then(response => response.json())
        .then(response => {
          dispatch({
            type: SHOW_DELETERESUME_DATA,
            payload: response
          })
          if (response[0].success) {
            return dispatch(getJobseekerProfile(jobseekerId));
          } else {
            swal(response[0].msg);
            return dispatch(getJobseekerProfile(jobseekerId));
          }
        })
        .catch(err => {
          console.error('Failed Resume Delete:', err)
          dispatch({
            type: DELETERESUME_LOAD_FAIL,
            payload: err
          })
        })
    })
  }
}

export const deleteVideoResume = (jobseekerId) => {
  console.log('deleteVideoResume action called', jobseekerId)
  return (dispatch) => {
    dispatch({ type: DELETEVIDEO_DATA_LOADING })
    helpers.getServerUrl().then((url) => {
      // var fileUrl = url.imageUrl
      // var fileUrl = "http://localhost:4141"
      fetch(url.serverUrl + "jobseeker/deleteVideoResume", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          jobseekerId: jobseekerId
        })
      })
        .then(response => response.json())
        .then(responseData => {
          dispatch({
            type: SHOW_DELETERESUME_DATA,
            payload: responseData
          })
          if (responseData[0].success) {
            return dispatch(getJobseekerProfile(jobseekerId));
          } else {
            swal(responseData[0].msg);
            return dispatch(getJobseekerProfile(jobseekerId));
          }
        })
        .catch(err => {
          dispatch({
            type: DELETEVIDEO_LOAD_FAIL,
            payload: err
          })
        })
    })
  }
}

export const updateProfileApi = (body) => {
  return (dispatch) => {
    dispatch({ type: LOADING_UPDATED_DATA })
    helpers.getServerUrl().then(url => {
      var url = url.serverUrl
      helpers.getServerUrl().then(url => {
        var url = url.serverUrl
        fetch(url + "/jobseeker/updateProfile", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(body)
        })
          .then(response => response.json())
          .then(responseData => {
            dispatch({
              type: DATA_UPDATED,
              payload: responseData
            })
          })
          .catch(err => {
            dispatch({
              type: DATA_UPDATED_FAIL,
              payload: err
            })
          })
      })
    })
  }
}
